import { getLoginLinkQueryKey, getLogoutLinkQueryKey } from '@ui/constants';
import { env } from '@ui/environment';
import { axios } from '@ui/http';
import { RouteNames } from '@ui/routes';
import { setAccessToken } from '@ui/token-storage';
import { getAuthWorkerUrl } from '@ui/utils';
export async function login(queryClient, state) {
    setAccessToken(null, null);
    const request = getLoginLinkQueryKey.login(state);
    try {
        const response = await queryClient.fetchQuery(request);
        window.location.href = response;
    } catch (unused) {
        window.location.href = getAuthWorkerUrl(RouteNames.NOT_AUTHORIZED);
    }
}
export async function logout(queryClient) {
    const request = getLogoutLinkQueryKey.logout();
    try {
        const response = await queryClient.fetchQuery(request);
        setAccessToken(null, null);
        window.location.href = response;
    } catch (unused) {
        window.location.href = getAuthWorkerUrl(RouteNames.FORBIDDEN);
    }
}
// logout function without query, to be able to use without hook (as ex. in axios interceptor)
export async function directLogout() {
    try {
        const logoutUrl = new URL('/api/logout-link', env.PUBLIC_AUTH_API_BASE_URL);
        const returnTo = new URL('/', window.location.origin).toString();
        logoutUrl.searchParams.set('return_to', returnTo);
        const { data: redirectUrl } = await axios.get(logoutUrl.toString());
        setAccessToken(null, null);
        window.location.href = redirectUrl;
    } catch (unused) {
        window.location.href = getAuthWorkerUrl(RouteNames.FORBIDDEN);
    }
}
